import { app } from '../../../../../app';
import { Controller } from './configure-sso.controller';

app.component('companyManageApplicationIntegrationDevelopersConfigureSso', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./configure-sso.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/configure-sso/configure-sso.component.js